export default __webpack_public_path__ + "static/media/Front-Inizio-Sour.227997b5.jpg";